import { useList, useDetail, useCreate, useUpdate, useDelete, useListInfinite, useAction } from "@inmagik/react-crud"
import { Donatore, HistoricalInfo } from "../types"
import { API_URL } from "../constants"

export function useDonatoriList(params: Record<string, string> = {}) {
  return useList<Donatore>(`${API_URL}/donatori`, {
    query: params,
  })
}

export function useDonatore(id: number | undefined | string) {
  return useDetail<Donatore>(`${API_URL}/donatori`, id?.toString())
}

export function useDonatoreCreate() {
  return useCreate<Donatore>(`${API_URL}/donatori`)
}

export function useDonatoreUpdate() {
  return useUpdate<Donatore>(`${API_URL}/donatori`)
}

export function useDonatoreDelete() {
  return useDelete<Donatore>(`${API_URL}/donatori`)
}

export function useDonatoreHistory(id: number | string) {
  return useListInfinite<HistoricalInfo>(`${API_URL}/donatori/${id}/history`)
}

export function useDonatoreSetAllegati(id: number | string){
  return useAction(`${API_URL}/donatori/${id}/set-allegati`, {
    method: "POST",
    encode: 'formdata'
  })
}

